
//----------------------------------------------------------
// Generated file, DO NOT EDIT.

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.TestManagement.WebApi
//----------------------------------------------------------


export module TestManagementResourceIds {
    export var TestPlan = "72493ce2-021d-42c4-a9c9-e60d3335d27f";
    export var TestSuite = "82243633-baf3-423d-8cbd-b272a469febe";
    export var TestPoint = "3ecbe2f1-c419-4d6c-be9e-d2919bc7e581";
    export var TestResult = "271c7b73-c3f9-4022-8ad6-aa53b600aff9";
    export var TestRun = "dedd48a7-82f6-48ac-86e8-3e0a1d99d785";
    export var TestStatistics = "3b3adad0-61fb-462a-b906-c13d1b33d1fa";
    export var TestCoverage = "ac160fa4-78a2-4e25-87c2-73a0afe8f5d7";
    export var TestIterations = "5710d5f0-d129-4e85-a830-f8ea22968964";
    export var AreaName = "Test";
    export var TestPlanResource = "Plans";
    export var TestSuiteResource = "Suites";
    export var TestPointResource = "Points";
    export var TestResultResource = "Results";
    export var TestRunResource = "Runs";
    export var SuiteTestCaseResource = "TestCases";
    export var RunStatisticResource = "Statistics";
    export var RunCoverageResource = "Coverage";
    export var IterationsResource = "Iterations";
}
